import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useBusinessNumber } from '../../../../shared/hooks/useBusinessNumber.js';

interface ScorecardRow {
  readonly scorecardId: string;
  readonly periodType: string;
  readonly periodStart: string;
  readonly periodEnd: string;
  readonly compliancePct: number | null;
  readonly overallScore: number | null;
}

export function M21GovernanceScorecardPage(): ReactNode {
  const { decimal } = useBusinessNumber();
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<ScorecardRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: ScorecardRow[] }>('/v1/governance/scorecards', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m21.scorecard.loading')}</p>;
  return (
    <main aria-label="governance-scorecard">
      <h1>{t('m21.scorecard.title')}</h1>
      <table aria-label="scorecards-table">
        <thead><tr><th>{t('m21.scorecard.colPeriod')}</th><th>{t('m21.scorecard.colStart')}</th><th>{t('m21.scorecard.colEnd')}</th><th>{t('m21.scorecard.colCompliance')}</th><th>{t('m21.scorecard.colOverallScore')}</th></tr></thead>
        <tbody>
          {rows.map((s) => (
            <tr key={s.scorecardId}>
              <td>{s.periodType}</td>
              <td>{s.periodStart}</td>
              <td>{s.periodEnd}</td>
              <td>{decimal(s.compliancePct)}</td>
              <td>{decimal(s.overallScore)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
